import { render, staticRenderFns } from "./xmgk.vue?vue&type=template&id=3086220c&scoped=true&"
import script from "./xmgk.vue?vue&type=script&lang=js&"
export * from "./xmgk.vue?vue&type=script&lang=js&"
import style0 from "./xmgk.vue?vue&type=style&index=0&id=3086220c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086220c",
  null
  
)

export default component.exports